/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/OSL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/OSL-3.0 Open Software License (OSL 3.0)
 */
import $ from 'jquery'
import prestashop from 'prestashop'

export class ShowField {
    init() {
        const $contactForm = $('.contact-form form')
        const $orderField = $contactForm.find('[name="id_order"]')
        const _this = this

        $(document.body).on('change', '#id_contact', function () {
            return _this.required($orderField, $(this).val())
        })
    }

    required($element, value) {
        let selected = prestashop.modules.vecontactsubject.VE_CONTACT_SUBJECT_ID === value

        if(selected) {
            $element.parents('.form-group').find('.form-control-comment').hide()
        } else {
            $element.parents('.form-group').find('.form-control-comment').show()
        }

        return $element.attr('required', selected)
    }
}